import React from 'react';
import { PopupIds } from '../../../../../components/popupPanel/popupConstants';
import ToolbarPopup from '../../toolbarPopup/ToolbarPopup';
import CellTypePopup from '../../../../../element/table/cellTypes/CellTypePopup';
import { CellTypeNames } from '../../../../../../common/table/CellTypeConstants';

type CellTypePopupContainerProps = {
    isPopupOpen: boolean;
    buttonSelector: string;
    closePopup: () => void;
    showArrow?: boolean;
    lastClickedType: CellTypeNames | null;
    setLastClickedType: (type: CellTypeNames) => void;
    locale: string;
    activeCellType: CellTypeNames | undefined;
};

const CellTypePopupContainer: React.FC<CellTypePopupContainerProps> = ({ isPopupOpen, ...props }) => (
    <ToolbarPopup
        {...props}
        popupId={PopupIds.CELL_TYPE}
        ignoredClicksSelector=".RomaPopover"
        className="CellTypePopup"
        showArrow={true}
    >
        <CellTypePopup {...props} closePopup={null} />
    </ToolbarPopup>
);

export default CellTypePopupContainer;
